<dashboard-cmp
    *ngIf="accessToken"
    [facilityID]="facilityId"
    [accessToken]="accessToken"
    [_dashboardId]="dashboardId"
    [shared]="true"
    [_formParameters]="formParameters"
></dashboard-cmp>
